import { createContext, useContext, useEffect, useState, useCallback } from "react";
import PropTypes from "prop-types";
import {
  fetchEventos,
  createEvento,
  updateEventoApi,
  deleteEventoApi,
  addParticipantesAoEventoApi,
  removerParticipanteDoEventoApi,
  definirPagamentoApi,
} from "src/content/minipay/Configuracoes/eventosApi";

const MinipayEventosContext = createContext({
  eventos: [],
  loading: true,
  refresh: () => Promise.resolve([]),
  getEvento: () => null,
  addEvento: () => Promise.resolve(null),
  updateEvento: () => Promise.resolve(null),
  removeEvento: () => Promise.resolve(),
  addParticipantesAoEvento: () => Promise.resolve(null),
  removerParticipanteDoEvento: () => Promise.resolve(null),
  setPagamentoParticipante: () => Promise.resolve(null),
});

export function MinipayEventosProvider({ children }) {
  const [eventos, setEventos] = useState([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(() => fetchEventos().then((lista) => {
    setEventos(lista);
    return lista;
  }), []);

  useEffect(() => {
    refresh().finally(() => setLoading(false));
  }, [refresh]);

  const getEvento = useCallback((id) => eventos.find((e) => e.id === id) || null, [eventos]);

  const addEvento = useCallback((form) => createEvento(form).then((novo) => {
    setEventos((atual) => [...atual, novo]);
    return novo;
  }), []);

  const updateEvento = useCallback((id, patch) => updateEventoApi(id, patch).then((atualizado) => {
    setEventos((atual) => atual.map((e) => (e.id === atualizado.id ? atualizado : e)));
    return atualizado;
  }), []);

  const removeEvento = useCallback((id) => deleteEventoApi(id).then(() => {
    setEventos((atual) => atual.filter((e) => e.id !== id));
  }), []);

  const addParticipantesAoEvento = useCallback((eventoId, participanteIds) => (
    addParticipantesAoEventoApi(eventoId, participanteIds).then((atualizado) => {
      setEventos((atual) => atual.map((e) => (e.id === atualizado.id ? atualizado : e)));
      return atualizado;
    })
  ), []);

  const removerParticipanteDoEvento = useCallback((eventoId, participanteId) => (
    removerParticipanteDoEventoApi(eventoId, participanteId).then((atualizado) => {
      setEventos((atual) => atual.map((e) => (e.id === atualizado.id ? atualizado : e)));
      return atualizado;
    })
  ), []);

  const setPagamentoParticipante = useCallback((eventoId, participanteId, pago) => (
    definirPagamentoApi(eventoId, participanteId, pago).then((atualizado) => {
      setEventos((atual) => atual.map((e) => (e.id === atualizado.id ? atualizado : e)));
      return atualizado;
    })
  ), []);

  return (
    <MinipayEventosContext.Provider
      value={{
        eventos,
        loading,
        refresh,
        getEvento,
        addEvento,
        updateEvento,
        removeEvento,
        addParticipantesAoEvento,
        removerParticipanteDoEvento,
        setPagamentoParticipante,
      }}
    >
      {children}
    </MinipayEventosContext.Provider>
  );
}

MinipayEventosProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export function useEventos() {
  return useContext(MinipayEventosContext);
}

export default MinipayEventosContext;
